// extracted by mini-css-extract-plugin
export default {"root":"Profile_root__OaTeh"};